<!-- Card -->

<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">{{ 'bookingModule.bookings' | translate }}</h3>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div
    class="card-body pb-0"
    *ngIf="navigationForm.value.selectedType == 'bookings'"
  >
    <form [formGroup]="form" class="d-flex flex-wrap align-items-center mb-3">
      <label class="me-3">
        {{ 'general.date' | translate }}
      </label>
      <nz-range-picker
        [nzShowTime]="false"
        [nzSize]="'large'"
        formControlName="dateRange"
      ></nz-range-picker>
    </form>
    <common-booking-table
      [bookingTableOptions]="{
        hideTypeOfBooking: true,
        hideResource: true,
        hideTags: true,
        hideCheckbox: true
      }"
      [showTotal]="true"
      [tableData]="organizationBookings$ | async"
      (onClickRow)="onClickRow($event)"
      [isLoading]="isLoading$ | async"
    ></common-booking-table>
  </div>

  <!-- End Body -->
</section>
<!-- End Card -->
